import { type H3Event, getCookie } from 'h3';
import { parseValue } from '#shared/utils/session';
import type { ApiResponse  } from '#shared/types';
import { errorLog } from '#server/utils/logger';

export function getSessionCookiesOnServer(event: H3Event) {
  return Object.values(COOKIE).reduce((acc, cookie) => {
    acc[cookie] = parseValue(getCookie(event, cookie) || '');
    return acc;
  }, {} as Record<COOKIE, string | boolean | number | any[]>);
}

export function prepareError(event: any, response: ApiResponse, options?: {
  compress?: boolean;
  errorLogMessage?: string;
  params?: Record<string, any>;
}) {
  const { compress = true, errorLogMessage, params = {} } = options || {};
  const statusCode = response?.meta?.httpStatus || (response as any)?.statusCode;
  errorLog(errorLogMessage || response?.meta?.message, response?.meta?.requestId, params);
  setResponseStatus(event, statusCode || 404, response?.meta?.message || 'An error occurred');
  return compress ? compressResponse(event, response) : response;
}
